import { render, staticRenderFns } from "./ActivityButton.vue?vue&type=template&id=07967d72"
import script from "./ActivityButton.vue?vue&type=script&lang=js"
export * from "./ActivityButton.vue?vue&type=script&lang=js"
import style0 from "./ActivityButton.vue?vue&type=style&index=0&id=07967d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports